import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import { createConsultationNote, getConsultationNotes, getConsultationsList } from '../../../../../../../routes/doctor/consultation';
import TabRow from './TabRow';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { resetConsultationNote, DefaultPatientInfoLabels } from '../../../../../../../redux/features/doctor/Dashboard/consultation/consultationNote';
import { setIsRefreshTabs, setNotes, setNotesLength } from '../../../../../../../redux/features/doctor/Dashboard/consultation/consultation';


const Tab: React.FC = () => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const { consultationId, consultationNoteId } = useParams(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const accountInfo = useAppSelector(state => state.meta.accountInfo); 
    const notes = useAppSelector(state => state.consultation.notes); 
    const isRefreshTabs = useAppSelector(state => state.consultation.isRefreshTabs); 

    // -- 

    const handleNotesList = async () => { 
        const res = await getConsultationNotes(consultationId) as any;
        if (res?.data.status === 200) { 
            dispatch(setNotes(res.data.consultationNotes)); 
        }; 
    }; 

    // -- 

    const handleNoteCreation = async () => { 
        const content = { 
            consultationId: consultationId
        }; 

        let newArray = [] as any; 
        newArray = notes?.filter((note) => { 
            return note; 
        }); 
        newArray.unshift({ title: '', _id: '123' }); 
        dispatch(setNotes(newArray)); 
 
        const res = await createConsultationNote(content) as any; 

        if (res.data.status == 200) { 
            const translatedLabels: DefaultPatientInfoLabels = {
                name: t('pdf.label.name', 'Name:'),
                dob: t('pdf.label.dob', 'DOB:'),
                healthCard: t('pdf.label.healthCard', 'Health Card:'),
            };
            dispatch(resetConsultationNote({ labels: translatedLabels })); 
            navigate(`/consultation/${consultationId}/note/${res.data.consultationNote._id}`);
        }; 
    }; 

    // -- 

    useEffect(() => { 
        if (consultationId) { 
            handleNotesList(); 
        }; 
    },[consultationId]); 

    // -- 

    useEffect(() => { 
        if (isRefreshTabs) { 
            handleNotesList(); 
            dispatch(setIsRefreshTabs(false)); 
        }; 
    },[isRefreshTabs]); 

    // -- 

    useEffect(() => { 
        if (consultationNoteId) { 
            handleNotesList(); 
        }; 
    },[consultationNoteId]); 

    // -- 

    return (
      <Box sx={{ 
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          backgroundColor: colors?.interface,
      }}>
        <Box
            sx={{ 
                display: 'flex',
                flexDirection: 'row',
                width: notes?.length * 100,
                backgroundColor: colors?.interface,
                transition: 'width 0.3s',
            }}
        >
            {notes?.map((item, index) => (
                <TabRow key={index} item={item} />
            ))}
        </Box>
        <Box
            onClick={handleNoteCreation}
            sx={{ 
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-evenly', 
                cursor: 'pointer', 
                width: 30, 
                height: 30, 
                marginLeft: 1, 
                marginTop: 1, 
                borderRadius: '50%', 
                color: 'rgb(175, 175, 175)',
                '&:hover': { color: colors?.main }
            }}
        >
            <AddCircleOutlineIcon /> 
        </Box>
      </Box>
  );
};

export default Tab;